import { RiderLocation } from '../../RiderLocations/Location/Location.types';
import { LocationDraft } from '../types';

export const mapLocationsToFormValues = (
  locations: RiderLocation[]
): { locationDrafts: LocationDraft[]; originalLocationIds: number[] } => {
  const locationDrafts: LocationDraft[] = locations.map((loc) => ({
    draftId: crypto.randomUUID(),
    location: loc,
    formData: {
      locationId: loc.id,
      primary: loc.primary ?? false,
      mustBeMet: loc.mustBeMet ?? false,
      mustBeMetProtocol: {
        locationProtocol: loc.locationProtocol?.value ?? '',
        authorizedContactGroups: loc.authorizedContactGroups ?? [],
      },
      replaceLocation: loc.replaceLocation,
    },
    isNew: false,
  }));

  return { locationDrafts, originalLocationIds: locations.map((loc) => loc.id) };
};
